import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { AuthCallbackComponent } from './components/auth/auth-callback/auth-callback.component';
import { MemberCardComponent } from './components/member-card/member-card.component';
import { SingleSignOnComponent } from './components/single-sign-on/single-sign-on.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { BarcodeComponent } from './components/barcode/barcode.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TopUpAddressComponent } from './components/top-up-address/top-up-address.component';
import { PointsSummaryComponent } from './components/points-summary/points-summary.component';
import { EcashBalanceComponent } from './components/ecash-balance/ecash-balance.component';
import { RouterModule } from '@angular/router';
import { PointsSummaryBarComponent } from './components/points-summary-bar/points-summary-bar.component';
import { TransactionListComponent } from './components/transaction-list/transaction-list.component';
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PassesModule } from '../passes/passes.module';
import { BalanceBarComponent } from './components/balance-bar/balance-bar.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TmUserLoginComponent } from './components/tm-user-login/tm-user-login.component';
import { EditAccountDetailsComponent } from './components/edit-account-details/edit-account-details.component';
import { V1SingleSignOnComponent } from './components/v1-single-sign-on/v1-single-sign-on.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SingleSignOnAppComponent } from './components/single-sign-on-app/single-sign-on-app.component';
import { DateRangePickerModule } from '@fgb/portal-component-library/src/lib/shared/date-range-picker';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { AddCardPaymentComponent } from 'src/app/pages/features/jets-cash-section/add-card-payment/add-card-payment.component';

@NgModule({
  declarations: [
    AccountDetailsComponent,
    AuthCallbackComponent,
    MemberCardComponent,
    SingleSignOnComponent,
    BarcodeComponent,
    TopUpAddressComponent,
    EcashBalanceComponent,
    PointsSummaryComponent,
    PointsSummaryBarComponent,
    TransactionListComponent,
    TransactionHistoryComponent,
    BalanceBarComponent,
    TmUserLoginComponent,
    EditAccountDetailsComponent,
    V1SingleSignOnComponent,
    SingleSignOnAppComponent,
    AddCardPaymentComponent,
  ],
  exports: [
    AccountDetailsComponent,
    AuthCallbackComponent,
    MemberCardComponent,
    SingleSignOnComponent,
    BarcodeComponent,
    TopUpAddressComponent,
    EcashBalanceComponent,
    PointsSummaryComponent,
    PointsSummaryBarComponent,
    TransactionHistoryComponent,
    BalanceBarComponent,
    TmUserLoginComponent,
    EditAccountDetailsComponent,
    V1SingleSignOnComponent,
    SingleSignOnAppComponent,
    AddCardPaymentComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    RouterModule,
    InlineSVGModule,
    PassesModule,
    CarouselModule,
    DateRangePickerModule,
    DirectivesModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
})
export class UserModule { }
